import bannerImg from "./banner.png";
import BannerV2 from "./BannerV2.png";

import logo from "./logo.png";
import aboutSection1 from "./aboutSection1.png";
import anh3 from "./anh3.jpg";
import aboutUs from "./aboutUs.png"
import gift from "./giftImage.png" // TODO: thêm file gift.png vào thư mục này


import rings from "./rings.jpg"
import earrings from "./earrings.jpg"
import bracelets from "./bracelets4La.jpg"
import car from "./car.jpg"
import bocongthuong from "./bocongthuong.png"
const Images = {
  // banner Image of homepage
  bannerImage: bannerImg,

  // banner Image of colectionPage
  BannerV2Image: BannerV2,

  // logo wweb
  logoImage: logo,

  // image of AboutSection layout
  giftAboutImage: gift,

  aboutSection1Image: aboutSection1,
  anh3Image: anh3,
  aboutUsImage: aboutUs,

  // error image 
  ErrorImage: "https://placehold.net/default.svg",
  
  //box image
  ringsImage : rings,
  earringsImage : earrings,
  bracelets4laImage : bracelets,
  carImage : car,

  // 
  bocongthuongImage : bocongthuong

};

export default Images;

